'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024101 from "./presto.-Presto-Router$$anon$101.js";
import * as $j_presto$002e$002dSigned$002dDocuments$002dHistory$002dPage$0024 from "./presto.-Signed-Documents-History-Page$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$100() {
  this.bdR = null;
  this.bdJ = null;
  this.bdK = false;
  this.bdS = null;
  this.bdT = false;
  this.bdW = null;
  this.bdP = null;
  this.bdQ = false;
  this.bdL = null;
  this.bdM = false;
  this.bdN = null;
  this.bdO = false;
  this.bdU = false;
  this.bdV = false;
  this.bdR = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bdW = "SignedDocumentsHistoryPage";
}
export { $c_Lpresto_PrestoRouter$$anon$100 as $c_Lpresto_PrestoRouter$$anon$100 };
$p = $c_Lpresto_PrestoRouter$$anon$100.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$100;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$100() {
}
export { $h_Lpresto_PrestoRouter$$anon$100 as $h_Lpresto_PrestoRouter$$anon$100 };
$h_Lpresto_PrestoRouter$$anon$100.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bdR;
});
$p.M = (function() {
  if ((!this.bdK)) {
    this.bdJ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bdK = true;
  }
  return this.bdJ;
});
$p.O = (function() {
  if ((!this.bdT)) {
    this.bdS = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bdT = true;
  }
  return this.bdS;
});
$p.D = (function() {
  return this.bdW;
});
$p.t = (function() {
  if ((!this.bdQ)) {
    this.bdP = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bdQ = true;
  }
  return this.bdP;
});
$p.N = (function() {
  if ((!this.bdM)) {
    this.bdL = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bdM = true;
  }
  return this.bdL;
});
$p.Q = (function() {
  if ((!this.bdO)) {
    this.bdN = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024101.$c_Lpresto_PrestoRouter$$anon$101();
    this.bdO = true;
  }
  return this.bdN;
});
$p.v = (function() {
  if ((!this.bdV)) {
    this.bdU = false;
    this.bdV = true;
  }
  return this.bdU;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee611) => ((p) => \u03b4scrutinee611))($j_presto$002e$002dSigned$002dDocuments$002dHistory$002dPage$0024.$m_Lpresto_SignedDocumentsHistoryPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$100 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$100, "presto.PrestoRouter$$anon$100", ({
  Nw: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$100 as $d_Lpresto_PrestoRouter$$anon$100 };
//# sourceMappingURL=presto.-Presto-Router$$anon$100.js.map
